import { render } from "./Triggers.vue?vue&type=template&id=dab1d9d8&scoped=true"
import script from "./Triggers.vue?vue&type=script&lang=js"
export * from "./Triggers.vue?vue&type=script&lang=js"

import "./Triggers.vue?vue&type=style&index=0&id=dab1d9d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab1d9d8"]])

export default __exports__